import React from "react"
import Check from "../../assets/img/Check.svg"
import Translation from "../../services/translation.service"

const StepperStep = ({
title,
desc,
step,
status,
icon,
nonActive
}) => {

  const isActive = status === "inProgress" || status === "isDone"

    return (<div className="stepper-step-container">
      <div className="content-container">
      <div className="title-container">
            <img src={isActive ? icon: nonActive} alt="call"/>
          <p className={`title ${isActive ? "" : "inactive"}`}>
            {Translation.keys["stf-step"] || "Step"}: {step} {title}</p>
        </div>
        <p className={`desc ${isActive ? "": "inactive"}`}>{desc}</p>
      </div>
      {status === "isDone" && <img className="check" src={Check} alt="tick" />}
    </div>)
}

export default StepperStep